const hContentContainers = document.querySelectorAll('.h-tab_content');
const hContainerTabs = document.querySelectorAll(".h-tab_tab-head li");

const vContentContainers = document.querySelectorAll('.v-tab_content');
const vContainerTabs = document.querySelectorAll(".v-tab_tab-head li");

const switchToContactForm = document.querySelectorAll('.contact-form__switch');
switchToContactForm.forEach(function(btn) {
  btn.addEventListener('click', function() {
    window.location = '/pages/contact-us'
  });
});

const containersToggle = function(containers) {
  containers.forEach(function(container) {
    if (container.classList.contains('shown')) {
      container.classList.remove('shown')
    }
  });
};

const tabsToggle = function(tabs) {
  tabs.forEach(function(tab) {
    if (tab.classList.contains('active')) {
      tab.classList.remove('active');
    }
  });
};

const titleHeight = document.querySelector(".h-tab .h1-style").offsetHeight;
const headHeight = document.querySelector(".v-tab").offsetHeight;
const activeComponent = document.querySelector(".v-tab_content.shown");
const activeComponentHeight = activeComponent.offsetHeight;
activeComponent.closest('.h-tab_container').style.minHeight = activeComponentHeight + headHeight + titleHeight * 2 + 'px';

hContainerTabs.forEach(function(tab) {
  tab.addEventListener('click', function() {
    containersToggle(hContentContainers);
    tabsToggle(hContainerTabs);
    const activeTab = tab.getAttribute("rel");
    const activeContent = document.querySelector("#"+activeTab);
    const activeContetnId = activeContent.getAttribute("id");

    if (activeTab === activeContetnId && !activeContent.classList.contains('shown')) {
      activeContent.classList.add('shown');
      tab.classList.add('active');
    }

    const activeHorizontalComponent = document.querySelector(".h-tab_content.shown");
      setTimeout (function() {
      const verticalBlocks = activeHorizontalComponent.querySelectorAll('.v-tab_content');
        if (verticalBlocks.length === 0) {
        const activeHorizontalComponentHeight = activeHorizontalComponent.offsetHeight;
        activeHorizontalComponent.closest('.h-tab_container').style.minHeight = activeHorizontalComponentHeight + headHeight + titleHeight + 'px';
      } else {
        verticalBlocks.forEach(function(block) {
          if (block.classList.contains('shown')) {
            activeHorizontalComponent.closest('.h-tab_container').style.minHeight = block.offsetHeight + headHeight + titleHeight * 2 + 'px';
          }
        });
      }
    }, 0);
  })
});

const buttons = activeComponent.querySelectorAll('.cc-accordion-item__title');

buttons.forEach(function(button) {
  button.addEventListener('click', function() {
    setTimeout (function() {
      const parentHeight = activeComponent.offsetHeight;
      activeComponent.closest('.h-tab_container').style.minHeight = parentHeight + headHeight + titleHeight * 2 + 'px';
    }, 300);
  });
});

vContainerTabs.forEach(function(tab) {
  tab.addEventListener('click', function() {
    containersToggle(vContentContainers);
    tabsToggle(vContainerTabs);
    const activeTabId = tab.getAttribute("rel");
    const activeContent = document.querySelector("#"+activeTabId);
    const activeContetnId = activeContent.getAttribute("id");

    if (activeTabId === activeContetnId && !activeContent.classList.contains('shown')) {
      activeContent.classList.add('shown');
      tab.classList.add('active');
      const parentHeight = activeContent.offsetHeight;
      activeContent.closest('.h-tab_container').style.minHeight = parentHeight + headHeight + titleHeight * 2 + 'px';

      const activeButtons = activeContent.querySelectorAll('.cc-accordion-item__title');

      activeButtons.forEach(function(button) {
        button.addEventListener('click', function() {
          setTimeout (function() {
            const parentHeight = activeContent.offsetHeight;
            activeContent.closest('.h-tab_container').style.minHeight = parentHeight + headHeight + titleHeight * 2 + 'px';
          }, 300);
        });
      });
    }
  })
});
